import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesComponent } from './messages.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IonicModule } from '@ionic/angular';
import { ChatDatetimeModule } from 'src/app/pipe/chat-datetime/chat-datetime.module';
import { FormsModule } from '@angular/forms';
import { ListStatusModule } from 'src/app/share/list-status/list-status.module';
import { TruncateModule } from 'src/app/pipe/truncate/truncate.module';
import { AvatarModule } from 'src/app/share/avatar/avatar.module';
import { SanitizeModule } from 'src/app/pipe/sanitize/sanitize.module';

@NgModule({
	declarations: [MessagesComponent],
	exports: [MessagesComponent],
	imports: [
		CommonModule,
		IonicModule,
		FormsModule,
		FlexLayoutModule,
		ChatDatetimeModule,
		ListStatusModule,
		TruncateModule,
		AvatarModule,
		SanitizeModule,
		TranslateModule
	]
})
export class MessagesModule { }
